import { Controller } from "@hotwired/stimulus"

// Uses the native iOS share sheet inside Hotwire Native. The normal web share
// controller remains as a browser fallback.
export default class extends Controller {
  static values = { message: String, completionUrl: String }

  connect() {
    if (!this.nativeHandler) return

    this.element.classList.remove("hidden")
  }

  async share(event) {
    event.preventDefault()
    if (this.element.disabled) return

    this.element.disabled = true

    try {
      const result = await this.nativeHandler.postMessage({ message: this.messageValue })
      if (result.status === "sent") await this._notifyCompletion()
    } catch (error) {
      console.warn("[native-share] share failed", error)
    } finally {
      this.element.disabled = false
    }
  }

  get nativeHandler() {
    return window.webkit?.messageHandlers?.nativeShare
  }

  _notifyCompletion() {
    if (!this.hasCompletionUrlValue) return

    return fetch(this.completionUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content },
      credentials: "same-origin",
      keepalive: true
    }).then((response) => {
      if (!response.ok) throw new Error(`Completion returned ${response.status}`)
    })
  }
}
